import './BetbookRewardProgressBar.less';
import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { formatMoneyAmount } from '../../common/util';
import { FAILED, HIDDEN, PAID_OUT, PAID_OUT_WITH_BONUS } from './constants';
import i18n from '../../common/i18n';
import BonusCheckIcon from '../../icons/BonusCheckIcon';

export interface ProgressBarProps {
    status: string;
    value: number;
    maxValue: number;
    bonus?: number;
    bonusPercent?: number;
    className?: string;
    children?: ReactNode;
}

export default function BetbookRewardProgressBar({
    status,
    value,
    maxValue,
    bonus,
    bonusPercent,
    className,
    children
}: ProgressBarProps) {
    const percentValue = maxValue >= value && (value / maxValue) * 100;
    const checkerPercentProgress =
        percentValue || percentValue === 0 ? (percentValue > 96 ? percentValue - 2 : percentValue) : 98;
    return status !== HIDDEN ? (
        <div className={clsx('betbook-progress-bar', status, className)}>
            <div className={clsx('progress-bar-head', status)}>
                <div className="ml-10 mr-10 head-title">
                    {status !== FAILED
                        ? formatMoneyAmount(value, '€', 2) +
                          (bonus && status === PAID_OUT_WITH_BONUS ? ' + ' + formatMoneyAmount(bonus, '€') : '')
                        : i18n('betbook.reward.fail.condition')}
                </div>
                {bonusPercent && status === PAID_OUT_WITH_BONUS ? (
                    <div className="head-bonus">
                        <p className="head-bonus-title">
                            {bonusPercent * 100 + '%\u00A0' + i18n('nui.bonus.progress.bar')}
                        </p>
                    </div>
                ) : null}
                {status === FAILED && children}
            </div>
            <div className="progress-bar-bar">
                <div className="bar-texts">{i18n('nui.tournaments.reward')}</div>
                <div className="bar-wrapper">
                    <span className="bar">
                        <span
                            className={clsx('bar-progress-view', status)}
                            style={{ width: `${percentValue}%` }}
                        ></span>
                    </span>
                    {status === PAID_OUT || status === PAID_OUT_WITH_BONUS ? (
                        <span className="bar-bonus-check" style={{ marginLeft: `${checkerPercentProgress}%` }}>
                            <BonusCheckIcon />
                        </span>
                    ) : null}
                </div>
                <div className="bar-texts ml-5">{formatMoneyAmount(maxValue, '€', 2)}</div>
            </div>
        </div>
    ) : null;
}
